import { Highlight } from "components/Hightlight/Hightlight.style";
import styled from "styled-components";

export const OurWorkContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 49px;
  @media screen and (max-width: 1200px) {
    margin-bottom: 40px;
  }
`;
export const OurWorkIntro = styled.p`
  text-align: left;
  padding-bottom: 90px;
  font-size: 24px;
  font-weight: 400;

  margin: 32px 10px 0;
  letter-spacing: -0.5px;
  line-height: 150%;

  & ${Highlight} {
    font-stretch: normal;
  }

  @media screen and (max-width: 1200px) {
    margin: 0px;
    font-size: 18px;
  }
  @media screen and (max-width: 768px) {
    padding-bottom: 38px;
    line-height: 24px;
    font-size: 16px;
    letter-spacing: unset;
  }
`;

export const ImageContainer = styled.div`
  text-align: center;
  height: auto;
`;

export const ImageElementSimple = styled.img`
  border-radius: 16px;
  max-width: calc(100%);
  height: auto;
  @media (max-width: 768px) {
    border-radius: 32px;
  }
`;

export const YourIdeasContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  margin-bottom: 120px;
  @media screen and (max-width: 1200px) {
    gap: 32px;
    margin-bottom: 40px;
  }
  @media screen and (max-width: 768px) {
    gap: 0px;
  }
`;

export const YourIdeasText = styled.p`
  text-align: right;
  color: white;
  font-size: 32px;
  font-weight: 400;
  margin: 0px 10px;
  letter-spacing: -0.5px;
  line-height: 150%;

  & ${Highlight} {
    font-stretch: normal;
  }

  @media screen and (max-width: 1024px) {
    font-size: 28px;
    width: 100%;
    margin: 0px;
  }
  @media screen and (max-width: 768px) {
    padding-bottom: 32px;
    font-size: 20px;
    letter-spacing: 0px;
  }
`;

export const HelpContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 48px;
  margin-bottom: 120px;
  @media screen and (max-width: 1200px) {
    gap: 32px;
    margin-bottom: 40px;
  }
  @media screen and (max-width: 768px) {
    gap: 0px;
  }
`;

export const HelpText = styled.p`
  text-align: left;
  font-size: 32px;
  font-weight: 400;
  margin: 0px 10px;
  letter-spacing: -0.5px;
  line-height: 150%;

  & ${Highlight} {
    font-stretch: normal;
  }
  
  @media screen and (max-width: 1024px) {
    font-size: 28px;
    margin: 0px;
  }
  @media screen and (max-width: 768px) {
    padding-bottom: 32px;
    font-size: 20px;
    letter-spacing: 0px;
  }
`;
